<h1 mat-dialog-title class="dialog-header">{{ "easybill.assignVrsTitle" | translate }}</h1>

<mat-dialog-content class="mat-typography">
  <div class="current-info" *ngIf="data.currentVrs">
    <p><strong>{{ "easybill.currentVrs" | translate }}:</strong> {{ data.currentVrs }}</p>
  </div>

  <form [formGroup]="form" class="flex flex-col">
    <mat-form-field class="full-width">
      <mat-label>{{ "easybill.vrsLabel" | translate }}</mat-label>
      <input matInput formControlName="vrs" placeholder="z. B. VOL-2023-000123" />
      <mat-error *ngIf="form.get('vrs')?.hasError('required')">{{ "dialog.vrsError" | translate }}</mat-error>
      <mat-error *ngIf="form.get('vrs')?.hasError('minlength')">{{ "dialog.vrsError" | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>{{ "easybill.projectNameLabel" | translate }}</mat-label>
      <input matInput formControlName="projectName" />
    </mat-form-field>
  </form>

  <div class="error-message" *ngIf="errorMessage">{{ errorMessage | translate }}</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{ "Cancel" | translate }}</button>
  <button mat-flat-button color="primary" [disabled]="form.invalid || saving" (click)="assign()">
    {{ "easybill.assignVrs" | translate }}
  </button>
</mat-dialog-actions>
